import { BaseService } from './base-service';
import { StrainIndexReportMapper } from '@/core/mappers/strain-index-report';
import type { StrainIndexReport } from '@/types/StrainIndex';
import type {
	GetStrainIndexRiskDTO,
	GetStrainIndexRequestDTO,
	GetStrainIndexRiskParamsDTO,
	GetStrainIndexReportResponseDTO
} from '@/core/dto/strain-index';

export class StrainIndexReportService extends BaseService {
	private static instance: StrainIndexReportService;
	private constructor(public readonly basePath: string = '/ergonomic-tool/strain-index') {
		super();
	}

	public static getInstance(): StrainIndexReportService {
		if (!StrainIndexReportService.instance) {
			StrainIndexReportService.instance = new StrainIndexReportService();
		}
		return StrainIndexReportService.instance;
	}

	public async getStrainIndexRisk(params: GetStrainIndexRiskParamsDTO): Promise<GetStrainIndexRiskDTO> {
		const url = this.basePath + `/report/risk`;
		const { data } = await this.getInstance().get<GetStrainIndexRiskDTO>(url, { params });
		return data;
	}

	public async getReport(params: GetStrainIndexRequestDTO): Promise<StrainIndexReport> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().get<GetStrainIndexReportResponseDTO>(url, { params });
		return new StrainIndexReportMapper(data).toDomain();
	}
}
